// Problem Text Same Height

$(".problem-wrapper .problem-title").matchHeight();
$(".problem-wrapper .problem-text").matchHeight();
$(".problem-wrapper .button-tz").matchHeight();
$(".tz-product-list .productitem").matchHeight();
$(".tz-product-list .productitem--info").matchHeight();
$(".flickity-slider .productgrid--item").matchHeight();

// Page Redirect

$(document).ready(function () {

  $(".flickity-slider .productgrid--item").matchHeight();
  
  // Check if you are on a specific page (e.g., index.html)
  if (
    window.location.href.indexOf(
      "https://redmoringa.de/pages/finde-einen-handler"
    ) > -1
  ) {
    // Redirect to a new page (e.g., newpage.html)
    window.location.href = "https://redmoringa.de";
  }

  // Blog List Order according to date for all blogs page

  var blogList = $(".tz-blog--container .blog--inner");
  var blogItem = $(".tz-blog--container .article--excerpt-wrapper");

  blogItem.each(function () {
    // Convert the string in 'data-event-date' attribute to a more
    // standardized date format
    var BCDate = $(this).attr("data-event-date").split("-");
    var standardDate = BCDate[1] + " " + BCDate[0] + " " + BCDate[2];
    standardDate = new Date(standardDate).getTime();
    $(this).attr("data-event-date", standardDate);
  });

  blogItem
    .sort(function (a, b) {
      a = parseFloat($(a).attr("data-event-date"));
      b = parseFloat($(b).attr("data-event-date"));
      return a - b;
    })
    .each(function () {
      blogList.prepend(this);
    });

  // Show More Button
  var list = $(".tz-blog-all-wrapper .blog--inner li");
  var numToShow = 8;
  var button = $("#tz_next");
  var numInList = list.length;
  list.hide();
  if (numInList > numToShow) {
    button.show();
  }
  list.slice(0, numToShow).show();

  button.click(function () {
    var showing = list.filter(":visible").length;
    list.slice(showing - 1, showing + numToShow).fadeIn();
    var nowShowing = list.filter(":visible").length;
    if (nowShowing >= numInList) {
      button.hide();
    }
  });

  // Blog List Order according to date for all pages

  var pageList = $(".tz-latest-blog-list");
  var pageItem = $(".tz-latest-blog-list li");

  pageItem.each(function () {
    // Convert the string in 'data-event-date' attribute to a more
    // standardized date format
    var BCDate = $(this).attr("data-event-date").split("-");
    var standardDate = BCDate[1] + " " + BCDate[0] + " " + BCDate[2];
    standardDate = new Date(standardDate).getTime();
    $(this).attr("data-event-date", standardDate);
  });

  pageItem
    .sort(function (a, b) {
      a = parseFloat($(a).attr("data-event-date"));
      b = parseFloat($(b).attr("data-event-date"));
      return a - b;
    })
    .each(function () {
      pageList.prepend(this);
    });

  // var pageListShow= 5;
  // var pageItemLength = pageItem.length;
  // pageItem.hide();
  // pageItem.slice(0, pageListShow).show();

  // Image Lazy Loading
  $(".product-gallery--media-thumbnail-img-wrapper img").attr(
    "loading",
    "lazy"
  );

  // Change text for DE language

  function isGermanLanguage() {
    // Or you might check for a language attribute
    return $("html").attr("lang") === "de";
  }

  if (isGermanLanguage()) {
    
    var executionCount = 0; 
    var maxExecutions = 2; 
  
    // Change More Payment Option Button Text
    
    var intervalId = setInterval(function () {
      $(".shopify-payment-button__more-options").each(function () {
        var buttonText = $(this).text();
        // console.log(buttonText);
        if (buttonText.includes("Bezahlmöglichkeiten")) {
          $(this).text(
            buttonText.replace("Bezahlmöglichkeiten", "Zahlungsmöglichkeiten")
          );
        }
      });

      // Change PayPal Button Text
  
      $(
        'div[data-testid="PayPalInContext-button"] span:contains("kaufen")'
      ).each(function () {
        var text = $(this).text();
        $(this).text(text.replace("kaufen", "bezahlen"));
      });

      executionCount++;

      // Stop the interval after the specified number of executions
      if (executionCount >= maxExecutions) {
        clearInterval(intervalId);
      }
    }, 1000);
  }
  
  // New Landing Page

  if (window.location.href.indexOf("https://redmoringa.de/pages/landing-bf") > -1) {
    window.location.href = "https://redmoringa.de";
  }

  if (window.location.href.indexOf("https://redmoringa.fr/pages/landing-bf") > -1) {
    window.location.href = "https://redmoringa.fr";
  }

  if (window.location.href.indexOf("https://redmoringa.eu/pages/landing-bf") > -1) {
    window.location.href = "https://redmoringa.eu";
  }

  // Variant Name

  var initialValue = $('[data-variant-option-chosen-value]').attr('data-variant-option-chosen-value');

  function checkIfChanged() {
    var currentValue = $('[data-variant-option-chosen-value]').attr('data-variant-option-chosen-value');
    if (currentValue !== initialValue) {
        initialValue = currentValue;
        $('.tz-variant-name').text(currentValue);
    } else {
        $('.tz-variant-name').text(initialValue);
    }
  }
  
  $(document).on('change', '[data-variant-option-chosen-value]', function() {
    checkIfChanged();
  });

  // Hub Product Price

let previousContent = $('.qbk-offer-list--transition').html();

setInterval(function () {
    let currentContent = $('.qbk-offer-list--transition').html();

    if (currentContent !== previousContent) {
        const hubComparePrice = $('.qbk-volume-tier--selected .qbk-volume-tier__price--origin').text().trim();
        const hubCurrentPrice = $('.qbk-volume-tier--selected .qbk-volume-tier__price_section .qbk-volume-tier__price--offer:first-child').text().trim();
        
        if (hubComparePrice) {
            $('.tz-compare-price').text(hubComparePrice);
        } else {
            $('.tz-compare-price').text('');
        }

        if (hubCurrentPrice) {
            $('.tz-current-price').text(hubCurrentPrice);
            $('.tz-compare-price').show();
        } else if (hubComparePrice) {
            $('.tz-compare-price').hide();
            $('.tz-current-price').text(hubComparePrice);
        } else {
            $('.tz-current-price').text('');
        }
        previousContent = currentContent;
    }
}, 500);


  // $('.qbk-volume-tier__title').on('click', function () {
  //  console.log("volume change");
  // });


// checkPricesUntilAvailable();
  
});

// Lazy load image for background image

document.addEventListener("DOMContentLoaded", function () {
  var lazyBackgrounds = [].slice.call(
    document.querySelectorAll(".lazy-background")
  );
  // console.log(lazyBackgrounds);

  // var Imagesrc = $('.lazy-background').data('src');
  // console.log(Imagesrc);

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.backgroundImage =
            "url('" + entry.target.dataset.src + "')";
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});

// Video Slider
var swiper = new Swiper(".mySwiper", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 10,
  pagination: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1920: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    360: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

// FAQs

var acc = document.getElementsByClassName("course-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function () {
    var panel = this.nextElementSibling;
    var coursePanel = document.getElementsByClassName("course-panel");
    var courseAccordion = document.getElementsByClassName("course-accordion");
    var courseAccordionActive = document.getElementsByClassName("course-accordion active");
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      this.classList.remove("active");
    } else {
      for (var ii = 0; ii < courseAccordionActive.length; ii++) {
        courseAccordionActive[ii].classList.remove("active");
      }
      for (var iii = 0; iii < coursePanel.length; iii++) {
        this.classList.remove("active");
        coursePanel[iii].style.maxHeight = null;
      }
      panel.style.maxHeight = panel.scrollHeight + "px";
      this.classList.add("active");
    }
  };
}
